export default __webpack_public_path__ + "0dce1c34b54352dfbdc741efdfd19933.png";